//import { EntityContext } from '@app/collections/fortress/EntityContext'
//import { ProfileContext } from '@app/collections/fortress/ProfileContext'
import { Button, Description, DescriptionItem, If, Row, Select, Text } from '@app/components'
import { DownloadOutlined } from '@app/components/icons'
//import { IStore } from '@app/redux'
//import { auth } from '@app/services'
import { EComponentMode } from '@app/types'
import { Col } from 'antd'
//import axios from 'axios'
//import { isEmpty } from 'lodash'
import React, { useRef } from 'react'
//import { useSelector } from 'react-redux'

export const WireTransferContent: React.FC<any> = ({
  wireTransactionType,
  setWireTransactionType,
  mode,
  //setCurrentNode,
  handleImageSave,
  userMemo,
}) => {
  //const { user } = useSelector((state: IStore) => state)
  const componentRef = useRef()

  /*const [result, setResult] = useState<string | object>({})
  const { profileInfo, fetchProfile } = useContext(ProfileContext)
  const { entityInfo, fetchEntity } = useContext(EntityContext)

  useEffect(() => {
    const startCredit = async () => {
      try {
        const params = {
          custodialAccountId: user.selectedEntityCustodialId
            ? user.selectedEntityCustodialId
            : user.fortressCustodialId,
        }
        const authorization = await auth.currentUser.getIdToken()
        const headers = {
          Authorization: authorization,
        }
        const res = await axios.get('/api/fortress/wire', { params, headers })

        setResult(res.data.wire)
        setCurrentNode(componentRef.current)
      } catch (error) {
        setResult('Error fetching Account Details')
        // eslint-disable-next-line no-console
        console.log('Error fetching user wire resource', error)
        Notification({ message: error.response.data, type: 'error' })
      }
    }
    startCredit()
    fetchProfile()
    fetchEntity()
  }, [])*/

  //   const descriptionItemStyle: React.CSSProperties = {
  //     textAlign: 'right',
  //     display: 'block',
  //   }

  return (
    <Row gutter={[30, 30]}>
      <If condition={mode !== EComponentMode.VIEW}>
        <Col span={24}>
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Text>Select transfer type</Text>
            </Col>
            <Col span={24}>
              <Select
                width="100%"
                placeholder="Select transfer type"
                value={wireTransactionType}
                options={[
                  { value: 'wire-instructions', label: 'Domestic' },
                  { value: 'wire-instructions-intl', label: 'International' },
                ]}
                onChange={(v) => setWireTransactionType(v)}
              />
            </Col>
          </Row>
        </Col>
      </If>

      <Col span={24} ref={componentRef}>
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <Description column={1}>
              {wireTransactionType == 'wire-instructions-intl' && (
                <>
                  <DescriptionItem label="SWIFT Code/BIC">CHASUS33</DescriptionItem>
                  <DescriptionItem label="Bank Name">Chase Bank</DescriptionItem>
                  <DescriptionItem label="Bank Address"> 270 Park Avenue, New York, NY 10017, USA</DescriptionItem>

                  {/*<DescriptionItem label="Beneficiary Name">Horizon Bank</DescriptionItem>
                  <DescriptionItem label="Beneficiary Address">
                    600 West 5th Street, Suite 1500, Austin, TX 78701
                  </DescriptionItem>*/}

                  <DescriptionItem label="Recipient Name">CTS Global</DescriptionItem>
                  <DescriptionItem label="Account Number">2901988958</DescriptionItem>

                  <DescriptionItem label="Memo/Reference (Required)">{'CTS Global LLC / ' + userMemo}</DescriptionItem>
                  <DescriptionItem label="Email">{'info@ctsglobal.io'}</DescriptionItem>
                </>
              )}
              {wireTransactionType == 'wire-instructions' && (
                <>
                  {/*<DescriptionItem label="Routing Number">111907940</DescriptionItem>
                  <DescriptionItem label="Account Number">10285116</DescriptionItem>
                  <DescriptionItem label="Recipient Name">CTS Global LLC</DescriptionItem>

                  <DescriptionItem label="Bank Name">Horizon Bank of Texas</DescriptionItem>
                  <DescriptionItem label="Bank Address">
                    600 West 5th Street, Suite 1500, Austin, TX 78701
                  </DescriptionItem>*/}

                  <DescriptionItem label="Routing Number">111000614</DescriptionItem>
                  <DescriptionItem label="Account Number">2901988958</DescriptionItem>
                  <DescriptionItem label="Recipient Name">CTS Global LLC</DescriptionItem>

                  <DescriptionItem label="Bank Name">Chase Bank</DescriptionItem>
                  <DescriptionItem label="Bank Address">1001 S. Main St, Kalispell, Montana, 59901</DescriptionItem>

                  <DescriptionItem label="Memo/Reference (Required)">{userMemo}</DescriptionItem>
                  <DescriptionItem label="Email">{'info@ctsglobal.io'}</DescriptionItem>
                </>
              )}
            </Description>
          </Col>

          <Col>
            <Button type="default" icon={<DownloadOutlined />} onClick={() => handleImageSave(componentRef.current)}>
              Download
            </Button>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}
